import React from "react";
import "./StepsScreen.scss";
import Step1 from "../../Images/step1.png";
import Step2 from "../../Images/step2.png";
import Step3 from "../../Images/step3.png";
import tick from "../../Images/tick.svg";
import { Container } from "react-bootstrap";

const StepsScreen = () => {
  const data=[
    {
      id:1,
      img:Step1,
      title:"Step 1",
      tick:tick,
      description:"Choose or personalize your design"
    },
    {
      id:2,
      img:Step2,
      title:"Step 2",
      description:"Create a custom menu for your restaurant"
    },
    {
      id:3,
      img:Step3,
      title:"Step 3",
      description:"Start selling by sharing your app link or QR"
    }
  ]
  return (
    <Container>
          <div className="steps_screen_main_wrapper">
          <div className="upper_main_wrapper">
            <div className="upper_text_para">            
              <div className="upper_text_para_1">Create . Customize . Sell</div>
            </div>
            <div className="upper_text_para_3">Build Your Culinary Empire Today!</div>
          </div>
          <div className="below_text_para">
          Your one-stop shop to create an appealing food service app is here!
          Just follow these 3 simple steps to begin your journey in the food industry: 
          </div>
        </div>
        <div className="lower_wrapper">
          {/* <div className="lower_wrapper_sections">
            <h2>Step 1</h2>
            <p className="stepstextheight">Choose or personalize your design</p>
            <img src={Step1} />
          </div>
          <div className="lower_wrapper_sections">
            <h2>Step 2</h2>
            <p className="stepstextheight">Create a custom menu for your restaurant</p>
            <img src={Step2} />
          </div>
          <div className="lower_wrapper_sections">
            <h2>Step 3</h2>
            <p className="stepstextheight">Start selling by sharing your app link or QR</p>
            <img src={Step3} />
          </div> */}
          {
            data.map((item)=>{
              return(
                <div className="lower_wrapper_sections">
                  <div className="lower_imgWrapper">
                    <img src={item.img} alt="Steps" />
                   {item?.tick && <img src={item?.tick} alt="Tick" className="tickimage"/>}
                  </div>
                  <div>
                    <h2>{item.title}</h2>
                    <p className="stepstextheight">{item.description}</p>
                  </div>
                </div>
              )
            })
          }
        </div>
    </Container>
    // <div className="stepsscreendiv">
      
    // </div>
  );
};

export default StepsScreen;
